/* ============================================================
   E2O Theme — JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Hero Slider ─────────────────────────────────────── */
  function initHeroSlider() {
    const hero = document.querySelector('.hero');
    if (!hero) return;

    const slides = hero.querySelectorAll('.hero__slide');
    const dots = hero.querySelectorAll('.hero__dot');
    const counter = hero.querySelector('.hero__counter');
    const total = slides.length;
    let current = 0;
    let timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      current = (index + total) % total;
      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');
      if (counter) counter.textContent = '0' + (current + 1) + ' — 0' + total;
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { clearInterval(timer); goTo(i); startTimer(); }));

    function startTimer() { timer = setInterval(() => goTo(current + 1), 8500); }

    goTo(0);
    startTimer();
  }

  /* ── Cart Drawer ─────────────────────────────────────── */
  function initCartDrawer() {
    const overlay = document.getElementById('cart-overlay');
    const drawer = document.getElementById('cart-drawer');
    const openBtns = document.querySelectorAll('[data-cart-open]');
    const closeBtn = document.getElementById('cart-close');

    if (!drawer) return;

    function openCart() {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }

    function closeCart() {
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(btn => btn.addEventListener('click', openCart));
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);

    // Keyboard
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  }


  /* ── Fetch & Render Cart ─────────────────────────────── */
  function refreshCart() {
    const body = document.getElementById('cart-body');
    const countEls = document.querySelectorAll('[data-cart-count]');
    const subtotalEl = document.getElementById('cart-subtotal');
    const totalEl = document.getElementById('cart-total');
    const ecoBanner = document.getElementById('cart-eco-banner');
    const ecoText = document.getElementById('cart-eco-text');

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        var productItems = cart.items;
        var productCount = cart.item_count;
        var productSubtotal = cart.total_price;
        var shippingEl = document.getElementById('cart-shipping-note');

        // Nav badge vs drawer subtitle
        countEls.forEach(el => {
          if (el.closest('#cart-drawer')) {
            el.textContent = productCount + ' Curated Item' + (productCount !== 1 ? 's' : '');
            el.style.display = productCount > 0 ? 'block' : 'none';
          } else {
            el.textContent = productCount > 0 ? productCount : '';
            el.style.display = productCount > 0 ? 'flex' : 'none';
          }
        });

        // Footer section
        const drawerPromo = document.getElementById('drawer-promo');
        if (drawerPromo) drawerPromo.style.display = productCount > 0 ? 'block' : 'none';

        // Eco impact banner
        if (ecoBanner && ecoText) {
          if (productCount > 0) {
            const plasticKg = (productCount * 1.4).toFixed(1);
            const waterGal = productCount * 60;
            const carbonKg = (productCount * 3.4).toFixed(1);
            ecoText.innerHTML = 'Choosing e2o over conventional fashion could save around <strong>' + plasticKg + 'kg</strong> plastic, <strong>' + waterGal + ' gal</strong> water &amp; <strong>' + carbonKg + 'kg</strong> carbon on this order.';
            ecoBanner.style.display = 'flex';
          } else {
            ecoBanner.style.display = 'none';
          }
        }

        if (!body) return;

        if (productCount === 0) {
          body.innerHTML = '<p class="cart-drawer__empty" style="text-align:center;padding:40px 0;font-family:var(--font-decor);font-size:13px;color:var(--color-grey)">Your bag is empty.</p>';
          if (subtotalEl) subtotalEl.textContent = '$0.00';
          if (totalEl) totalEl.textContent = '$0.00';
          return;
        }

        function parseVariant(v) {
          if (!v || v === 'Default Title') return '';
          var parts = v.split(' / ');
          var labels = ['Color', 'Size', 'Style'];
          return parts.map(function(p, i) {
            return '<p style="font-family:var(--font-decor);font-size:11px;color:var(--color-grey);margin:1px 0">' + (labels[i] ? labels[i] + ': ' : '') + p + '</p>';
          }).join('');
        }

        body.innerHTML = productItems.map(function(item) {
          return '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid var(--color-light-grey);align-items:flex-start">' +
            '<div style="width:72px;height:90px;border-radius:8px;overflow:hidden;background:var(--color-beige);flex-shrink:0">' +
              '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" referrerpolicy="no-referrer" style="width:100%;height:100%;object-fit:cover">' +
            '</div>' +
            '<div style="flex:1;min-width:0">' +
              '<a href="' + item.url + '" style="display:block;font-family:var(--font-display);font-size:0.9rem;font-weight:600;color:var(--color-charcoal);text-decoration:none;margin:0 0 4px;line-height:1.3">' + item.product_title + '</a>' +
              parseVariant(item.variant_title) +
              '<div style="display:flex;align-items:center;gap:10px;margin-top:10px">' +
                '<button data-qty-change="' + item.key + '" data-delta="-1" style="width:26px;height:26px;border:1.5px solid var(--color-light-grey);background:none;border-radius:6px;cursor:pointer;font-size:14px;color:var(--color-charcoal)">−</button>' +
                '<span style="font-family:var(--font-decor);font-size:13px;font-weight:600;min-width:16px;text-align:center">' + item.quantity + '</span>' +
                '<button data-qty-change="' + item.key + '" data-delta="1" style="width:26px;height:26px;border:1.5px solid var(--color-light-grey);background:none;border-radius:6px;cursor:pointer;font-size:14px;color:var(--color-charcoal)">+</button>' +
              '</div>' +
            '</div>' +
            '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:12px;flex-shrink:0">' +
              '<p style="font-family:var(--font-decor);font-size:13px;font-weight:700;color:var(--color-charcoal);margin:0">' + formatMoney(item.line_price) + '</p>' +
              '<button data-remove-item="' + item.key + '" title="Remove" style="background:none;border:none;cursor:pointer;color:#CBD5E0;padding:2px;transition:color 0.2s" onmouseover="this.style.color=\'#E53E3E\'" onmouseout="this.style.color=\'#CBD5E0\'">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>';
        }).join('');


        // Shipping note — honest (free over $150, otherwise calculated at checkout)
        if (shippingEl) shippingEl.textContent = productSubtotal >= 15000 ? 'FREE' : 'Calculated at checkout';

        // Totals
        if (subtotalEl) subtotalEl.textContent = formatMoney(productSubtotal);
        if (totalEl) totalEl.textContent = formatMoney(productSubtotal);

        // Qty buttons
        body.querySelectorAll('[data-qty-change]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var key = btn.dataset.qtyChange;
            var delta = parseInt(btn.dataset.delta);
            var item = cart.items.find(function(i) { return i.key === key; });
            if (!item) return;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: Math.max(0, item.quantity + delta) })
            }).then(function() { refreshCart(); });
          });
        });

        // Remove buttons
        body.querySelectorAll('[data-remove-item]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: btn.dataset.removeItem, quantity: 0 })
            }).then(function() { refreshCart(); });
          });
        });
      });
  }

  /* ── Add to Cart ─────────────────────────────────────── */
  function initAddToCart() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      e.preventDefault();
      const variantId = btn.dataset.addToCart || btn.closest('form[data-product-form]')?.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          refreshCart();
          // Open cart drawer
          document.getElementById('cart-overlay')?.classList.add('is-open');
          document.getElementById('cart-drawer')?.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          showNotification('Added to your conscious bag!');
        })
        .finally(() => {
          btn.disabled = false;
          btn.textContent = btn.dataset.labelDefault || 'Quick Add';
        });
    });
  }

  /* ── Product Form ────────────────────────────────────── */
  function initProductForm() {
    // The product template renders a Shopify {% form 'product' %} with id="product-form".
    const form = document.querySelector('[data-product-form]') || document.getElementById('product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const id = form.querySelector('[name="id"]').value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1');
      const btn = form.querySelector('[data-submit-btn]') || document.getElementById('add-to-cart-btn');
      const label = btn ? btn.textContent : '';

      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      })
        .then(r => r.json())
        .then(() => {
          // Update the bag count + toast. On desktop, also reveal the drawer.
          refreshCart();
          showNotification('Added to your bag');
          // Desktop only: reveal the cart drawer after adding (mobile stays as-is)
          if (window.matchMedia('(min-width: 768px)').matches) {
            var d = document.getElementById('cart-drawer');
            var o = document.getElementById('cart-overlay');
            if (d) d.classList.add('is-open');
            if (o) o.classList.add('is-open');
          }
        })
        .finally(() => {
          if (btn) { btn.disabled = false; btn.textContent = label || 'Add to Bag'; }
        });
    });
  }

  /* ── Search Overlay ──────────────────────────────────── */
  function initSearch() {
    const searchBtn = document.getElementById('search-btn');
    const searchOverlay = document.getElementById('search-overlay');
    const searchClose = document.getElementById('search-close');
    const searchInput = document.getElementById('search-input');

    if (!searchBtn || !searchOverlay) return;

    searchBtn.addEventListener('click', () => {
      searchOverlay.classList.toggle('is-open');
      if (searchOverlay.classList.contains('is-open') && searchInput) {
        searchInput.focus();
      }
    });

    if (searchClose) searchClose.addEventListener('click', () => searchOverlay.classList.remove('is-open'));

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') searchOverlay.classList.remove('is-open');
    });
  }

  /* ── Mobile "Shop" category menu ─────────────────────── */
  function initMobileShopMenu() {
    const toggle = document.querySelector('[data-mobile-shop-toggle]');
    const menu = document.querySelector('[data-mobile-shop-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', e => {
      if (!menu.classList.contains('is-open')) return;
      if (menu.contains(e.target) || toggle.contains(e.target)) return;
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* ── Variant Selector (Product Page) ────────────────── */
  function initVariantSelector() {
    const btns = document.querySelectorAll('[data-variant-option]');
    const hiddenInput = document.querySelector('[name="id"]');
    if (!btns.length || !hiddenInput) return;

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Mark active within same option group
        const group = btn.dataset.optionGroup;
        document.querySelectorAll(`[data-variant-option][data-option-group="${group}"]`)
          .forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        // Try to find matching variant
        const allSelected = {};
        document.querySelectorAll('[data-variant-option].is-selected').forEach(b => {
          allSelected[b.dataset.optionGroup] = b.dataset.optionValue;
        });

        const variants = JSON.parse(document.getElementById('product-variants-json')?.textContent || '[]');
        const match = variants.find(v => {
          return v.options.every((opt, i) => allSelected[i] === opt);
        });

        if (match) {
          hiddenInput.value = match.id;
          const priceEl = document.getElementById('product-price');
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          if (match.available) {
            document.querySelector('[data-submit-btn]')?.removeAttribute('disabled');
          } else {
            document.querySelector('[data-submit-btn]')?.setAttribute('disabled', 'true');
          }
        }
      });
    });
  }

  /* ── Gallery Thumbnails ──────────────────────────────── */
  function initGallery() {
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const mainImg = document.querySelector('.product-gallery__main img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        mainImg.src = thumb.dataset.src;
      });
    });
  }

  /* ── Collection Filter (category pills) ─────────────── */
  function initCollectionFilter() {
    const pills = document.querySelectorAll('.category-pill');
    const cards = document.querySelectorAll('.product-card[data-pill-cat]');
    if (!cards.length) return;
    const subSelect = document.querySelector('.subcat-select');
    const sustainSelect = document.querySelector('.sustain-select');

    const params = new URLSearchParams(window.location.search);
    let state = { type: params.get('type') || '', standard: params.get('standard') || '' };

    function apply() {
      pills.forEach(p => p.classList.toggle('is-active', (p.dataset.filterCat || '') === state.type));
      if (subSelect) subSelect.value = state.type;
      if (sustainSelect) sustainSelect.value = state.standard;
      let visible = 0;
      cards.forEach(card => {
        const okType = !state.type || card.dataset.pillCat === state.type;
        const sustain = ' ' + (card.dataset.sustain || '') + ' ';
        const okStd = !state.standard || sustain.indexOf(' ' + state.standard + ' ') > -1;
        const show = okType && okStd;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      const countEl = document.querySelector('.collection-count');
      if (countEl) countEl.textContent = visible;
      const emptyEl = document.querySelector('.collection-empty');
      if (emptyEl) emptyEl.style.display = visible === 0 ? 'block' : 'none';
    }

    function pushURL() {
      const url = new URL(window.location.href);
      state.type ? url.searchParams.set('type', state.type) : url.searchParams.delete('type');
      state.standard ? url.searchParams.set('standard', state.standard) : url.searchParams.delete('standard');
      history.pushState(null, '', url.toString());
    }

    apply();

    pills.forEach(pill => {
      pill.addEventListener('click', e => {
        e.preventDefault();
        state.type = pill.dataset.filterCat || '';
        pushURL(); apply();
      });
    });
    if (subSelect) subSelect.addEventListener('change', () => { state.type = subSelect.value; pushURL(); apply(); });
    if (sustainSelect) sustainSelect.addEventListener('change', () => { state.standard = sustainSelect.value; pushURL(); apply(); });

    window.addEventListener('popstate', () => {
      const p = new URLSearchParams(window.location.search);
      state = { type: p.get('type') || '', standard: p.get('standard') || '' };
      apply();
    });
  }

  /* ── Newsletter Form ─────────────────────────────────── */
  function initNewsletter() {
    const form = document.querySelector('.site-footer__newsletter-form');
    if (!form) return;
    form.addEventListener('submit', e => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]').value;
      if (email) {
        showNotification('Thanks for joining! Zero-waste updates incoming.');
        form.reset();
      }
    });
  }

  /* ── Notification ────────────────────────────────────── */
  function showNotification(msg) {
    const el = document.getElementById('cart-notification');
    if (!el) return;
    el.querySelector('p').textContent = msg;
    el.classList.add('is-visible');
    setTimeout(() => el.classList.remove('is-visible'), 4000);
  }
  // Exposed for inline onclick handlers used in templates (e.g. Size Chart Helper)
  window.showNotification = showNotification;

  /* ── Helpers ─────────────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Init ────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initHeroSlider();
    initCartDrawer();
    initAddToCart();
    initProductForm();
    initSearch();
    initMobileShopMenu();
    initVariantSelector();
    initGallery();
    initNewsletter();
    initCollectionFilter();
    refreshCart();
  });

})();
